import plusImg from '../../../assets/images/icons/plus.svg'
import minusImg from '../../../assets/images/icons/minus.svg'
import { useCallback, useContext, useEffect, useState } from 'react'
import { sampleDefault, SamplesContext, SamplesResponseType, UpdateSamplesContext } from '../../../context/samplesContext'
import { Modal } from '../../../components/Modal'
import { UpdateUserContext, UserContext } from '../../../context/userContext'
import { useParams } from 'react-router-dom'
import { SIZE_LIST } from '../../utils/helper'

export function InputContainer({ setIsUpdate }: { setIsUpdate: React.Dispatch<React.SetStateAction<boolean>> }) {
  const { rowSample } = useContext(SamplesContext)
  const { updateRowSample, decrement, increment, idSearchSample } = useContext(UpdateSamplesContext)
  const { isAuth } = useContext(UserContext)
  const { setIsAuth } = useContext(UpdateUserContext)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const openModal = useCallback(() => { setIsModalOpen(true) }, [])
  const closeModal = useCallback(() => { setIsModalOpen(false) }, [])
  const [modalType, setModalType] = useState<'part_number' | 'sample_number'>()
  const { sampleId } = useParams()

  useEffect(() => {
    if (sampleId) {
      setIsAuth(false)
      idSearchSample(sampleId, false, true) // URLに直接入力した場合編集不可
    }
  }, [sampleId, idSearchSample, setIsAuth])

  return (
    <div>
      <div className="flex mb-[15px] flex-col">
        <div className='flex space-x-[5px] justify-between desktop-xmd:contents desktop-xmd:space-x-0'>
          <div className='flex mb-[12px] space-x-[5px] desktop-xmd:justify-between'>
            <label className="flex items-center text-white text-[12px] min-w-[66px]">
              <span className='min-w-fit'>量産</span>
              <input
                type="radio"
                name="type"
                className="ml-[5px] w-[32px] h-[32px] accent-[#545899]"
                checked={rowSample.kind === 'final'}
                onChange={() => { if (isAuth) updateRowSample(({ kind: 'final' })) }}
                readOnly={!isAuth}
              />
            </label>
            <label className="flex items-center text-white text-[12px] min-w-[85px]">
              <span className='min-w-fit'>サンプル</span>
              <input
                type="radio"
                name="type"
                className="ml-[5px] w-[32px] h-[32px] accent-[#545899]"
                checked={rowSample.kind === 'sample'}
                onChange={() => { if (isAuth) updateRowSample(({ kind: 'sample' })) }}
                readOnly={!isAuth}
              />
            </label>
          </div>
          <div className="flex items-center justify-between mb-[8px] min-w-[155px]">
            <span className="text-white text-[12px] min-w-fit">リピート</span>
            <div className="flex items-center justify-between bg-white w-[100px] h-[36px] rounded-[5px] desktop-xmd:w-[129px]">
              <button
                className={`w-[25px] h-[25px] rounded-full ml-[18px] ${!isAuth && 'cursor-auto'}`}
                onClick={() => {
                  if (!isAuth) return
                  if (rowSample.repeat <= 0) return
                  decrement()
                }}
                disabled={!isAuth}
              >
                <img src={minusImg} alt='minus' />
              </button>
              <span className={`${rowSample.repeat === 0 ? 'text-[#B1B1B1]' : 'text-black'}`}>{rowSample.repeat}</span>
              <button
                className={`w-[25px] h-[25px] rounded-full mr-[18px] ${!isAuth && 'cursor-auto'}`}
                onClick={() => { if (isAuth) increment() }}
                disabled={!isAuth}
              >
                <img src={plusImg} alt='plue' />
              </button>
            </div>
          </div>
          <button
            onClick={() => {
              if (!isAuth) return
              setModalType('part_number')
              openModal()
            }}
            className={`min-w-[100px] w-full h-[36px] rounded-[5px] pl-[10px] mb-[8px] bg-white flex items-center desktop-xmd:w-full ${!isAuth && 'cursor-auto'}`}
            disabled={!isAuth}
          >
            <span className={`${rowSample.part_number ? 'text-black' : 'text-gray-400'} text-xs desktop-xmd:text-sm`}>{rowSample.part_number || '品番入力'}</span>
          </button>
          <button
            onClick={() => {
              if (!isAuth) return
              setModalType('sample_number')
              openModal()
            }}
            className={`min-w-[100px] w-full h-[36px] rounded-[5px] pl-[10px] mb-[8px] bg-white flex items-center desktop-xmd:w-full ${!isAuth && 'cursor-auto'}`}
            disabled={!isAuth}
          >
            <span className={`${rowSample.sample_number ? 'text-black' : 'text-gray-400'} text-xs desktop-xmd:text-sm`}>{rowSample.sample_number || 'サンプルNo入力'}</span>
          </button>
          <select
            className="min-w-[90px] h-[36px] rounded-[5px] pl-[10px] mb-[8px] disabled:opacity-100 desktop-xmd:w-full"
            value={rowSample.time}
            onChange={(e) => { if (isAuth) updateRowSample(({ time: parseInt(e.target.value) })) }}
            aria-readonly={!isAuth}
            disabled={!isAuth}
          >
            <option hidden></option>
            <option value={1}>1st</option>
            <option value={2}>2nd</option>
            <option value={3}>3rd</option>
            <option value={4}>4th</option>
            <option value={5}>5th</option>
          </select>
          <div className="relative min-w-[90px] h-[36px] mb-[8px] desktop-xmd:w-full">
            <select
              className="w-full h-full pl-[10px] pr-[10px] rounded-[5px] bg-white disabled:opacity-100"
              value={rowSample.size}
              onChange={(e) => { if (isAuth) updateRowSample({ size: e.target.value }) }}
              aria-readonly={!isAuth}
              disabled={!isAuth}
            >
              <option hidden></option>
              {Object.entries(SIZE_LIST).map(([groupKey, groupData]) => (
                <optgroup key={groupKey} label={groupData.label}>
                  {groupData.size.map(size => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
          </div>
        </div>
        <div className='flex space-x-[5px] desktop-xmd:contents desktop-xmd:space-x-0'>
          <input
            type="text"
            placeholder="Color入力"
            className="min-w-[140px] w-full h-[36px] pl-[10px] rounded-[5px] text-xs desktop-xmd:w-full desktop-xmd:mb-[8px] desktop-xmd:text-sm"
            value={rowSample.color_no}
            onChange={(e) => { if (isAuth) updateRowSample(({ color_no: e.target.value })) }}
            readOnly={!isAuth}
          />
          <input
            type="text"
            placeholder="アイテム名入力"
            className="min-w-[140px] w-full h-[36px] rounded-[5px] pl-[10px] text-xs desktop-xmd:w-full desktop-xmd:mb-[8px] desktop-xmd:text-sm"
            value={rowSample.item_name || ''}
            onChange={(e) => { if (isAuth) updateRowSample(({ item_name: e.target.value })) }}
            readOnly={!isAuth}
          />
          <input
            type="text"
            placeholder="ブランド名入力"
            className="min-w-[140px] w-full h-[36px] rounded-[5px] pl-[10px] text-xs desktop-xmd:w-full desktop-xmd:mb-[8px] desktop-xmd:text-sm"
            value={rowSample.brand_name || ''}
            onChange={(e) => { if (isAuth) updateRowSample(({ brand_name: e.target.value })) }}
            readOnly={!isAuth}
          />
          <div className="flex items-center justify-between min-w-[135px] desktop-xmd:mb-[8px]">
            <span className="text-white text-[12px] min-w-fit">識別結果</span>
            <input
              type="text"
              className="w-20 h-[36px] pl-[10px] rounded-[5px] text-xs desktop-xmd:w-[129px] desktop-xmd:text-sm"
              value={rowSample.clothtype || ''}
              readOnly
            />
          </div>
          <div className='flex items-center justify-between min-w-[155px]'>
            <span className='text-white text-[12px] min-w-fit'>重量結果(g)</span>
            <input
              type='text'
              className='w-20 h-[36px] rounded-[5px] pl-[10px] text-xs desktop-xmd:w-[129px] desktop-xmd:text-sm'
              value={rowSample.sampleWeightMeasurements[0]?.weight || ''}
              readOnly
            />
          </div>
        </div>
      </div>
      <LinkingModal isOpen={isModalOpen} modalType={modalType} onClose={closeModal} setIsUpdate={setIsUpdate} />
    </div>
  )
}

function LinkingModal({ isOpen, modalType, onClose, setIsUpdate }: { isOpen: boolean, modalType?: string, onClose: () => void, setIsUpdate: React.Dispatch<React.SetStateAction<boolean>> }) {
  const { rowSample, samples } = useContext(SamplesContext)
  const { updateRowSample } = useContext(UpdateSamplesContext)

  const [relatedSamples, setRelatedSamples] = useState<SamplesResponseType[]>([])
  const [selectedSample, setSelectedSample] = useState<SamplesResponseType>(sampleDefault)
  const [modalChildrenType, setModalChildrenType] = useState<'link' | 'confirm'>('link')

  const [value, setValue] = useState<string>('')

  useEffect(() => {
    if (modalType === 'part_number') {
      setValue(rowSample.part_number || '')
    } else if (modalType === 'sample_number') {
      setValue(rowSample.sample_number || '')
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  useEffect(() => {
    setModalChildrenType('link')
    setSelectedSample(sampleDefault)
  }, [isOpen])

  useEffect(() => {
    let filteredSamples: SamplesResponseType[] = [];

    if (modalType === 'part_number') {
      if (value) {
        const group = samples.filter(
          el =>
            el.sample_number === rowSample.sample_number &&
            el.part_number !== null &&
            el.part_number !== '' &&
            el.id !== rowSample.id
        )

        const allEmptyPart = group.every(el => !el.part_number)
        if (allEmptyPart) {
          filteredSamples = []
        } else if (value) {
          filteredSamples = group.filter(el =>
            el.part_number?.toLowerCase().includes(value.toLowerCase())
          )
        } else {
          filteredSamples = []
        }
      } else {
        filteredSamples = []
      }
    }
    else if (modalType === 'sample_number') {
      if (value) {
        filteredSamples = samples.filter(
          el =>
            el.sample_number?.toLowerCase().includes(value.toLowerCase()) &&
            el.id !== rowSample.id
        )
      } else {
        filteredSamples = []
      }
    }

    // ─────────── 空レコード除外 ───────────
    filteredSamples = filteredSamples.filter(
      el =>
        (el.sample_number !== null && el.sample_number !== '') ||
        (el.part_number !== null && el.part_number !== '')
    );

    // ─────────── 重複除外（最新レコードを優先） ───────────
    const deduped = Object.values(
      filteredSamples.reduce<Record<string, SamplesResponseType>>((acc, cur) => {
        const key = modalType === 'part_number'
          ? cur.part_number!
          : cur.sample_number!;

        const prev = acc[key];
        if (!prev) {
          acc[key] = cur;
        } else {
          const prevDate = prev.updated_at !== 'batch'
            ? new Date(prev.updated_at)
            : new Date(prev.created_at);
          const curDate = cur.updated_at !== 'batch'
            ? new Date(cur.updated_at)
            : new Date(cur.created_at);

          if (curDate > prevDate) {
            acc[key] = cur;
          }
        }
        return acc;
      }, {})
    );

    setRelatedSamples(deduped);
  }, [value, samples, modalType, rowSample]);

  const linkedSample = useCallback(() => {
    const propertiesToUpdate: (keyof SamplesResponseType)[] = [
      'part_number',
      'sample_number',
      'item_name',
      'repeat',
      'brand_name'
    ];

    (Object.keys(rowSample) as (keyof SamplesResponseType)[]).forEach((key) => {
      if (
        propertiesToUpdate.includes(key) &&
        (rowSample[key] === null || rowSample[key] === '' || rowSample[key] === 0)
      ) {
        updateRowSample(({ [key]: selectedSample[key] }))
      }
    })
  }, [rowSample, selectedSample, updateRowSample])

  const onClickLink = useCallback(() => {
    if (modalType === 'part_number') {
      const newValue = selectedSample.part_number ? selectedSample.part_number : value
      setModalChildrenType('confirm')
      updateRowSample({ part_number: newValue })
    } else if (modalType === 'sample_number') {
      const newValue = selectedSample.sample_number ? selectedSample.sample_number : value
      linkedSample()
      updateRowSample({ sample_number: newValue })
      onClose()
    }
  }, [modalType, linkedSample, onClose, updateRowSample, value, selectedSample])

  const onClickConfirm = useCallback((bol: boolean) => {
    if (bol) {
      linkedSample()
      setIsUpdate(true)
    } else {
      linkedSample()
      setIsUpdate(false)
    }
    onClose()
  }, [linkedSample, onClose, setIsUpdate])

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={modalChildrenType === 'link' ? 'flex flex-col w-[600px] h-[600px] px-5 py-[15px]' : 'flex flex-col w-[500px] h-[300px] px-5 py-[15px]'}
    >
      {modalChildrenType === 'link' ? (
        <>
          <div className='flex items-center w-full'>
            <div className='w-2 h-[35px] rounded-sm bg-[#3E3E3E] mr-[5px]' ></div>
            <span className='text-[#3E3E3E] text-[16px]'>
              {modalType === 'part_number' ? '品番入力' : 'サンプルNo入力'}
            </span>
          </div>
          <div className='mt-[25px]'>
            <input
              className='w-full h-[40px] rounded-[5px] pl-[10px] border-[#545899] border-[2px] outline-none'
              placeholder={modalType === 'part_number' ? '品番入力' : 'サンプルNo入力'}
              value={
                modalType === 'part_number' ?
                  (selectedSample.part_number ? selectedSample.part_number : value)
                  : (selectedSample.sample_number ? selectedSample.sample_number : value)
              }
              onChange={(e) => { setValue(e.target.value) }}
            />
          </div>
          <div className='flex flex-col h-full mt-[15px]'>
            <div className='flex flex-col h-[300px]'>
              <span>過去サンプル</span>
              <div className='w-full h-full overflow-y-auto ml-[5px] mt-[5px]'>
                {relatedSamples.length === 0 ? (
                  <span className='text-[14px]'>
                    該当サンプルが見つかりませんでした。
                  </span>
                ) :
                  relatedSamples.map((el, index) => (
                    <label className='flex items-center' key={index}>
                      <input type='radio' name='linked' className='w-[12px] h-[12px] accent-[#545899]' onClick={() => setSelectedSample(el)} />
                      <span className='ml-[5px] text-[14px]'>
                        {modalType === 'part_number' ? `${el.part_number} Repeat: ${el.repeat}` : `${el.sample_number} Repeat: ${el.repeat}`}
                      </span>
                    </label>
                  ))}
              </div>
            </div>
          </div>
          <div className='flex justify-end w-full mt-[25px]'>
            <button
              onClick={() => {
                onClickLink()
              }}
              className='w-[160px] h-[47px] bg-[#C5C7FF] rounded-[50px] text-[#545899] font-bold'
            >
              確定
            </button>
          </div>
        </>
      ) : (
        <div className='flex flex-col w-full h-full items-center justify-center'>
          <div>過去サンプルも併せて紐付けしますか？</div>
          <span className='text-[12px]'>※SAVEを行うまで実行されません</span>
          <div className='mt-[45px] space-x-[25px]'>
            <button
              className='border border-[#C5C7FF] rounded-[50px] w-[150px] h-[50px] text-[#545899] font-semibold'
              onClick={() => onClickConfirm(false)}
            >
              いいえ
            </button>
            <button
              className='rounded-[50px] w-[150px] h-[50px] bg-[#C5C7FF] text-[#545899] font-semibold'
              onClick={() => onClickConfirm(true)}
            >
              はい
            </button>
          </div>
        </div>
      )}
    </Modal>
  )
}